var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.679 20.54v1.451c0 1.43-1.114 2.96-2.453 3.41l-3.589 1.192c-.63.213-1.653.213-2.272 0L10.776 25.4c-1.35-.45-2.452-1.98-2.452-3.409V20.53c0-.889.99-1.429 1.732-.945l2.318 1.507c.888.597 2.013.89 3.138.89s2.25-.293 3.14-.89l2.283-1.496a1.124 1.124 0 0 1 1.744.945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.738 4.845c-1.215-.8-3.217-.8-4.432 0l-6.773 4.42c-2.171 1.407-2.171 4.59 0 6.008l1.8 1.17 4.973 3.24c1.215.8 3.217.8 4.432 0l4.939-3.24 1.541-1.012v3.442a.85.85 0 0 0 .844.844.85.85 0 0 0 .844-.844v-5.535c.45-1.45-.012-3.138-1.429-4.072l-6.739-4.421z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon-15.ffe3da22fb4bf9862cb84d371c166411.svg";
export { ForwardRef as ReactComponent };